import { createReducer } from 'redux-create-reducer';

import {
  CANCEL_COMMENT_CHANGED,
  CANCEL_REPAIR_SUCCESS,
  CANCEL_REPAIR_FAILURE,
  CANCELING_REPAIR,
  RESCHEDULE_REPAIR_SUCCESS,
  RESCHEDULE_REPAIR_FAILURE,
  RESCHEDULING_REPAIR,
  REPAIR_FETCHING,
  REPAIR_FETCHED,
  REPAIR_FETCHED_ERROR,
  CREATING_REPAIR,
  CREATE_REPAIR_SUCCESS,
  CREATE_REPAIR_FAILURE,
  SUBMIT_REPAIR_FAILED,
  SUBMITTING_REPAIR,
  ACCEPT_OEM_DISCLAIMER,
  CUSTOMER_DETAILS_FETCHED,
  RESET_DEVICE_DETAILS,
  TRANSLATED_ISSUES,
} from '../actions';

const initialState = {
  address: '',
  cancellationError: false,
  rescheduleError: false,
  cancellationComment: '',
  device: { name: '' },
  end: null,
  error: '',
  id: '',
  issues: [],
  issuesDescription: '',
  preciseTimes: false,
  repairIsLoading: false,
  repairState: 'requested',
  specialInstructions: '',
  start: null,
  utcOffset: -new Date().getTimezoneOffset(),
  customerAgreement: { oemAcceptedAt: '' },
  createdAt: '',
  expired: null,
  translatedIssues: [],
};

const mapIncomingRepair = repair => {
  if (repair.expired === true) {
    return { ...initialState, expired: true };
  }
  const {
    device = { model_options: { name: '' } },
    customer_precise_time,
    id,
    issues,
    issues_description,
    masked_phone_number,
    scheduled_window_end,
    scheduled_window_start,
    state,
    user_location = { display_address: '' },
    special_instructions,
    time_offset,
    time_zone,
    estimated_technician_arrival_time,
    created_at,
    translated_issues,
  } = repair;

  return {
    address: user_location.display_address,
    device: { name: device.model_options.name },
    end: scheduled_window_end,
    id,
    issues: issues,
    issuesDescription: issues_description,
    maskedPhoneNumber: masked_phone_number,
    preciseTimes: customer_precise_time,
    repairState: state,
    specialInstructions: special_instructions,
    start: scheduled_window_start,
    timeZone: time_zone,
    utcOffset: time_offset * 60,
    estimatedTechnicianArrivalTime: estimated_technician_arrival_time,
    createdAt: created_at,
    expired: false,
    translatedIssues: translated_issues,
  };
};

const events = {
  [CANCEL_COMMENT_CHANGED]: (state, { comment }) => {
    return { ...state, cancellationComment: comment };
  },

  [CANCELING_REPAIR]: state => ({
    ...state,
    repairIsLoading: true,
  }),

  [CANCEL_REPAIR_FAILURE]: state => {
    return {
      ...state,
      cancellationError: true,
      repairIsLoading: false,
    };
  },

  [CANCEL_REPAIR_SUCCESS]: (state, { repair }) => {
    return {
      ...state,
      cancellationError: false,
      ...mapIncomingRepair(repair),
      repairIsLoading: false,
    };
  },
  [ACCEPT_OEM_DISCLAIMER]: state => ({
    ...state,
    customerAgreement: {
      oemAcceptedAt: new Date(),
    },
  }),

  [RESCHEDULING_REPAIR]: state => ({
    ...state,
    errorMessage: '',
    rescheduleError: false,
    repairIsLoading: true,
  }),

  [RESCHEDULE_REPAIR_FAILURE]: (state, { error }) => {
    return {
      ...state,
      errorMessage: error,
      rescheduleError: true,
      repairIsLoading: false,
    };
  },

  [RESCHEDULE_REPAIR_SUCCESS]: (state, { start, end }) => {
    return {
      ...state,
      rescheduleError: false,
      start,
      end,
      repairIsLoading: false,
    };
  },

  [REPAIR_FETCHED]: (state, { repair }) => {
    return {
      ...state,
      ...mapIncomingRepair(repair),
      repairIsLoading: false,
    };
  },

  [REPAIR_FETCHED_ERROR]: state => ({ ...state, repairIsLoading: false }),

  [REPAIR_FETCHING]: state => ({ ...state, repairIsLoading: true }),

  [CREATING_REPAIR]: state => ({
    ...state,
    error: '',
    repairIsLoading: true,
  }),

  [CREATE_REPAIR_SUCCESS]: state => ({ ...state, repairIsLoading: false }),

  [CREATE_REPAIR_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    repairIsLoading: false,
  }),

  [SUBMITTING_REPAIR]: state => ({ ...state, repairIsLoading: true }),

  [SUBMIT_REPAIR_FAILED]: (state, { error }) => ({
    ...state,
    repairIsLoading: false,
    error: error.message,
  }),

  [CUSTOMER_DETAILS_FETCHED]: (
    state,
    { id, warrantyStatus, hasAppleCare, unsupportedProduct }
  ) => ({
    ...state,
    id,
    warrantyStatus,
    appleCare: hasAppleCare,
    unsupportedProduct: { ...unsupportedProduct },
  }),

  [RESET_DEVICE_DETAILS]: state => ({ ...state, unsupportedProduct: false }),

  [TRANSLATED_ISSUES]: (state, { translatedIssues }) => ({
    ...state,
    translatedIssues,
  }),
};

export default createReducer(initialState, events);
